<template>
  <div class="form-actions">
    <div v-if="address.name !== undefined">
      <validation-provider
        name="name"
        rules="required|invalidchars"
        slim>
        <template v-slot="{ errors }">
          <oie-base-input-v2
            v-model="address.name"
            required
            :label="`${tStatic('addressNameLabel')}`"
            :placeholder="tStatic('addressNamePlaceholder')"
            :errors="errors"></oie-base-input-v2>
        </template>
      </validation-provider>
    </div>

    <validation-provider
      rules="invalidchars"
      slim>
      <template v-slot="{ errors }">
        <oie-base-input-v2
          v-model="address.addressCo"
          data-pw="address-co"
          :label="tStatic('addressCoLabel')"
          maxlength="50"
          :placeholder="tStatic('addressCoPlaceholder')"
          :errors="errors"></oie-base-input-v2>
      </template>
    </validation-provider>

    <validation-provider rules="required|invalidchars" slim>
      <template v-slot="{ errors }">
        <oie-base-input-v2
          v-model="address.addressLine1"
          data-pw="address-line1"
          required
          :label="`${tStatic('addressStreetLabel')}`"
          :placeholder="tStatic('addressStreetPlaceholder')"
          maxlength="50"
          :errors="errors"></oie-base-input-v2>
      </template>
    </validation-provider>

    <validation-provider :rules="createPostalCodeValidationRule" slim>
      <template v-slot="{ errors }">
        <oie-base-input-v2
          v-model="proxyPostalCode"
          data-pw="address-postal-code"
          required
          :mask="createPostalCodeMask"
          :label="`${tStatic('addressPostalLabel')}`"
          :placeholder="tStatic('addressPostalPlaceholder')"
          maxlength="20"
          :errors="errors"
          @blur="handlePostalCodeBlur"></oie-base-input-v2>
      </template>
    </validation-provider>

    <validation-provider rules="required|invalidchars" slim>
      <template v-slot="{ errors }">
        <oie-base-input-v2
          v-model="address.city"
          data-pw="address-city"
          required
          :label="`${tStatic('addressCityLabel')}`"
          :placeholder="tStatic('addressCityPlaceholder')"
          maxlength="30"
          :errors="errors"></oie-base-input-v2>
      </template>
    </validation-provider>

    <oie-base-input-v2
      v-if="(countryList.length === 1) || (countryList.length > 1 && address.countryName)"
      v-model="address.countryName"
      :label="tStatic('addressCountryLabel')"
      :placeholder="tStatic('addressCountryPlaceholder')"
      readonly></oie-base-input-v2>

    <oie-base-dropdown
      v-else-if="countryList.length > 1 && useCountryDropdown"
      v-model="address.countryCode"
      :label-text="tStatic('addressCountryLabel')"
      :default-selected="createDefaultSelection"
      :options="countryList"
      :name="createDropdownName"
      :initial-text="createInitialText"
      container-classes="order-request__dropdown">
    </oie-base-dropdown>
  </div>
</template>

<script>
import countryHandling from '@/mixins/country-handling'
import Vue from 'vue'

export default {
  mixins: [countryHandling],
  props: {
    id: {
      type: String,
      required: true
    },
    address: {
      type: Object,
      required: true
    },
    useCountryDropdown: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      proxyPostalCode: null
    }
  },
  computed: {
    activeCountry() {
      return this.address.countryCode === null ? this.defaultCountry.value : this.countryList.find(a => { return a.value === this.address.countryCode })
    },
    createDropdownName() {
      return `${this.id}AddressCountryDropDown`
    },
    createPostalCodeValidationRule() {
      let countryCode

      if (!this.hasDefaultCountry) {
        countryCode = this.address.countryName !== null ? this.address.countryCode : null
      } else {
        countryCode = this.address.countryCode !== null ? this.address.countryCode : this.defaultCountry.value
      }

      let country = this.countryList.find(a => { return a.value === countryCode })
      let regex = country ? country.postalCodeRule : ''
      return countryCode ? `required|postalCode:${countryCode},${regex}` : null
    },
    createPostalCodeMask() {
      return this.address.countryCode ? this.activeCountry.postalCodeMask : null
    },
    createDefaultSelection() {
      return this.defaultCountry ? this.defaultCountry.value : this.address.countryCode
    },
    createInitialText() {
      return !this.hasDefaultCountry ? this.tStatic('addressCountryPlaceholder') : null
    }
  },
  watch: {
    'address.countryCode'() {
      if(this.address.countryCode !== null) {
        this.address.countryName = this.activeCountry.text
      }
    },
    'address.postalCode'(newValue) {
      if(newValue !== this.proxyPostalCode) {
        this.proxyPostalCode = newValue
      }
    }
  },
  mounted() {
    if (this.hasDefaultCountry && this.address.countryCode === null) {
      this.address.countryCode = this.defaultCountry.value
      this.address.countryName = this.defaultCountry.text
    }

    this.proxyPostalCode = this.address.postalCode

    this.setCountryOnEditMode()
  },
  updated() {
    if (this.hasDefaultCountry && this.address.countryCode === null) {
      this.address.countryCode = this.defaultCountry.value
      this.address.countryName = this.defaultCountry.text
    }

    this.setCountryOnEditMode()
  },
  methods: {
    handlePostalCodeBlur() {
      Vue.set(this.address, 'postalCode', this.proxyPostalCode)
    },
    setCountryOnEditMode() {
      if (this.address.id && this.address.countryName === null) {
        this.address.countryName = this.activeCountry.text
      }

      if (this.hasDefaultCountry && this.address.countryName === null) {
        this.address.countryName = this.defaultCountry.text
      }
    }
  }
}
</script>
